export enum PlanningInterviewStatusEnum {
  PLANNED = 'planned',
  IN_PROGRESS = 'in_progress',
  FINISHED = 'finished',
}
